// page function
// to keep track of page hit
const writeKeyGA = process.env.REACT_APP_GA_API_KEY
const page = (pageName: string, consent: { ga: boolean } | null) => {
 if(consent && consent.ga && window.gtag) {
  window.gtag('event', 'page_view', {
       page_title: pageName,
       send_to: writeKeyGA
     })
 }
}

 export default page